import { useEffect, useState } from 'react';

// True on devices whose primary input can't hover (touchscreens). Hover-reveal
// affordances double as a tap trap there: iOS Safari treats the first tap on a
// hover-revealing element as the hover (showing the hidden control) and
// swallows that tap's click, so the real action needs a second tap. Components
// use this to render such controls in their resting-visible state on touch
// instead of gating them behind a pointer hover.
//
// SSR-safe: defaults to false (matching the server render) and resolves on the
// client in an effect, so it never causes a hydration mismatch.
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(false);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia('(hover: none)');
    setCoarse(mq.matches);
    const update = () => setCoarse(mq.matches);
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  return coarse;
}
